exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn-separator:after{content:\" \";display:block;float:left;height:3px;width:2px}.select2-results__options{overflow-x:hidden !important}textarea.form-control{resize:vertical;overflow-y:auto}\n", ""]);

